import { AuthRepository } from "../repositories/AuthRepository";

export class SetPassword {
  constructor(private repository: AuthRepository) {}

  execute(params: SetPasswordParams): Promise<void> {
    return this.repository.setPassword(params.password);
  }
}

export class SetPasswordParams {
  constructor(public password: string) {}
}
